const topics = [
  { id: 1, name: '庆余年2大结局', heat: '128万讨论', tag: '热' },
  { id: 2, name: '与凤行吻戏名场面', heat: '96万讨论', tag: '爆' },
  { id: 3, name: '狐妖小红娘特效', heat: '83万讨论', tag: '热' },
  { id: 4, name: '墨雨云间反转剧情', heat: '71万讨论', tag: '新' },
  { id: 5, name: '玫瑰的故事穿搭美学', heat: '65万讨论', tag: '热' },
  { id: 6, name: '古装剧服化道盘点', heat: '58万讨论', tag: '' },
  { id: 7, name: '悬疑剧高能推荐', heat: '52万讨论', tag: '' },
  { id: 8, name: '年代剧经典重温', heat: '47万讨论', tag: '' },
  { id: 9, name: '仙侠剧天花板排行', heat: '43万讨论', tag: '新' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            追剧圈最火的话题讨论，加入大家一起聊剧
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full cursor-pointer transition-all duration-300 bg-background-100 border border-background-200 hover:border-primary-300 hover:bg-primary-50"
            >
              {topic.tag && (
                <span className={`px-1.5 py-0.5 rounded text-[10px] font-bold leading-none ${
                  topic.tag === '爆'
                    ? 'bg-primary-500 text-white'
                    : topic.tag === '热'
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-secondary-500 text-background-50'
                }`}>
                  {topic.tag}
                </span>
              )}
              <span className="text-sm text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">
                #{topic.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}